import { styled, Theme } from '@mui/material';

const bodyBoldDark = (theme: Theme) => ({
	...theme.typography.body2,
	fontWeight: 700,
	color: '#0E1C5B',
});

export const PassengerInfo = styled('div', {
	shouldForwardProp: (prop) =>
		prop !== 'disabledText' &&
		prop !== 'highlighted' &&
		prop !== 'hasSeparator',
})<{
	disabledText?: boolean;
	highlighted?: boolean;
	hasSeparator?: boolean;
}>(({ theme, disabledText, highlighted, hasSeparator }) => {
	let color;

	if (highlighted !== undefined) {
		color = highlighted
			? theme.palette.primary.dark
			: theme.palette.neutral[60];
	}

	if (disabledText !== undefined) {
		color = disabledText
			? theme.palette.neutral[60]
			: theme.palette.primary.dark;
	}

	color = color ?? theme.palette.text.primary;

	return {
		...theme.typography.body2,
		fontWeight: 700,
		color,
		overflow: 'hidden',
		display: 'flex',
		flexDirection: 'column',
		gap: 8,

		'#more-attendees': {
			...theme.typography.caption,
			color,
		},

		...(hasSeparator && {
			'&:not(:last-of-type)': {
				marginBottom: 16,
				paddingBottom: 16,
				borderBottom: '1px solid RGBA(14,28,91,0.1)',
			},
		}),
	};
});

export const NameAndId = styled('div')(({ theme }) => ({
	maxWidth: '100%',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	gap: 4,

	'& > *:first-child': {
		...bodyBoldDark(theme),
		flexGrow: 1,
		minWidth: 0,
		overflow: 'hidden',
		whiteSpace: 'pre-wrap',
		display: '-webkit-box',
		WebkitLineClamp: 2,
		WebkitBoxOrient: 'vertical',
		textOverflow: 'ellipsis',
	},

	'& > *:last-child': {
		...bodyBoldDark(theme),
		flexShrink: 0,
		whiteSpace: 'nowrap',
	},
}));

export const BookingCodeRow = styled('div')(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	alignSelf: 'stretch',

	'& > *:first-child': {
		...bodyBoldDark(theme),
		lineHeight: '22px',
		letterSpacing: '0.3px',
	},

	'& > *:last-child': {
		...bodyBoldDark(theme),
		fontSize: 28,
		lineHeight: '42px',
		letterSpacing: 2,
	},
}));
